import { useMutation } from "@tanstack/react-query";
import { deleteModuleTemplate } from "../api/deleteModuleTemplate";
import { invalidateActiveModuleTemplateListQuery } from "../queries/useActiveModuleTemplateList";
import { invalidateModuleTemplatePagedListQuery } from "../queries/useModuleTemplatePagedListQuery";

export const useDeleteModuleTemplateMutation = (callback: () => void) => {
  return useMutation({
    mutationFn: async (moduleId: string) => {
      return await deleteModuleTemplate(moduleId);
    },
    onSuccess: () => {
      invalidateModuleTemplatePagedListQuery();
      invalidateActiveModuleTemplateListQuery();
      callback();
    },
    onError: (e) => {
      console.error("Error occurred when deleting module", e);
    },
  });
};
